import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  formData: any;
  apiUrl: string =  environment.empUrl;
  webApiUrl: string = environment.webApiUrl;

  
  // Auth URLs
  login = "/login";
  logout = "/logout";
  signup = "/signup";

  constructor(
    private _http: HttpClient,
    private _router: Router
  ) { }

  /************** Base HTTP Request Methods *****************/

  /**
   * To Get Http Request for REST API
   * @param URL 
   * @param Options  
   */
   doGET(URL: string, Options?: any) {
    return this._http.get(this.apiUrl+URL, Options);
  }

  /**
   * To Get Http Request for REST API
   * @param URL 
   * @param Options  
   */
   doGETWeb(URL: string, Options?: any) {
    return this._http.get(this.webApiUrl+URL, Options);
  }
  
  /**
   * To Get Http Request for REST API
   * @param URL 
   * @param Options  
   */
  doGETUrl(URL: string, Options?: any) {
    return this._http.get(URL, Options);
  }

  /**
   * To Post Http Request for REST API
   * @param URL   // The Endpoint URL
   * @param Body    //Post Input Body
   * @param Options   //Headers or Other Optional Params
   */
  doPOST(URL: string, Body: any, Options?: any) {
    this.formData = Body;
    return this._http.post(URL, Body, Options);
  }

  /**
   * To Post Http Request for REST API
   * @param URL   // The Endpoint URL
   * @param Body    //Post Input Body
   * @param Options   //Headers or Other Optional Params
   */
  doPOSTUrl(URL: string, Body: any, Options?: any) {
    this.formData = Body;
    return this._http.post(URL, Body, Options);
  }

  /**
   * To Update Http Request for REST API
   * @param URL 
   * @param Body 
   * @param Options 
   */
  doPUT(URL: string, Body: any, Options?: any) {
    return this._http.put(this.apiUrl+URL, Body, Options);
  }

  /**
   * To Delete Http Request for REST API
   * @param URL 
   * @param Options 
   */
  doDelete(URL: string, Body?: any) {
    let options: any;
    if (Body) {
      options = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: Body,
      };
    }
    return this._http.delete(this.apiUrl+URL, options);
  }

  /**
   * Redirect to URL
   * @param URL 
   */
  redirectTo(url: string) {
    this._router.navigate([url]);
  }
}
